import React, { useRef, useState } from 'react';
import './NewCategoryRequest.scss';

import pageTextConfig from '../../../../assets/configs/Categories Page/textConfig';
import SnackBar, { SnackTypes } from '../../../UtilityComponents/SnackBar/SnackBar';
import GGLoaderView from '../../../UtilityComponents/GGLoaderView/GGLoaderView';
import HoneypotField from '../../../CommonComponents/HoneypotField/HoneypotField';
import { FeedbackAPIHandler } from '../../../../services/NetworkClient/BackendAPIs/FeedbackAPIHandler';
import { HONEYPOT_FIELD_NAME } from '../../../../utils/honeypot';

const emptyFormData = {
  email: '',
  categoryName: '',
  subcategoryName: '',
  comments: '',
  [HONEYPOT_FIELD_NAME]: ''
};

const NewCategoryRequest = () => {
  const { heading, para, input0, input1, input2, textArea } = pageTextConfig.RequestNew;
  const [loading, setLoading] = useState(false);
  const snackBarRef = useRef<{ showSnackbar(): any }>(null)
  const [snackBarParams, setSnackBarParams] = useState({
    message: "",
    state: SnackTypes.error
  });

  const showSnackbar = (message: string, state: SnackTypes) => {
    setSnackBarParams({ message: message, state: state })
    snackBarRef.current?.showSnackbar()
  }

  // Initialize the state to hold the form values
  const [formData, setFormData] = useState(emptyFormData);

  // Handle change for the input fields
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true)
    try {
      const success = await FeedbackAPIHandler.shared.postCategorySuggestion(formData);
      if (success) {
        showSnackbar("Feedback submitted successfully!", SnackTypes.success)
        setFormData(emptyFormData)
      }
      else
        throw new Error("Failed to submit feedback.")
    } catch (error) {
      showSnackbar(error as string, SnackTypes.error)
    } finally {
      setLoading(false)
    }
  };

  return (
    <section className='categoryRequestNew' id="request-new-category">
      {loading && <GGLoaderView />}
      <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />
      <h1>{heading}</h1>
      <p>{para}</p>
      <form onSubmit={handleSubmit} className="categoryForm">
        <HoneypotField
          value={formData[HONEYPOT_FIELD_NAME]}
          onChange={handleChange}
        />
        <div className="categoryFormBox">
          <div className="categoryForm-left">
            <input
              type="email"
              name="email"
              placeholder={input0}
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="text"
              name="categoryName"
              placeholder={input1}
              value={formData.categoryName}
              onChange={handleChange}
            />
            <input
              type="text"
              name="subcategoryName"
              placeholder={input2}
              value={formData.subcategoryName}
              onChange={handleChange}
            />
          </div>
          <div className="categoryForm-right">
            <textarea
              name="comments"
              placeholder={textArea}
              value={formData.comments}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        <button type="submit">Submit</button>
      </form>
    </section>
  );
};

export default NewCategoryRequest;
